<template>
  <div>


    <div class="rn-blog-area rn-section-gap">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <SectionTitle
                text-align="center"
                subtitle="Latest News"
                title="最新动态"
                description=""
                data-aos="fade-up"
            />
          </div>
        </div>
        <div class="row row--15 ">
          <div class="col-lg-12">
            <div class="row row--15">
              <div class="col-lg-4 col-md-6 col-sm-12 col-12 mt--30"
                   data-aos="slide-up"
                   data-aos-duration="800"
                   :data-aos-delay="100 + index"
                   v-for="(blog, index) in newsList"
                   :key="index">
                <HomePost :blog="blog" />
              </div>
            </div>
          </div>
          <div class="col-lg-12 text-center">
            <div class="rwt-load-more text-center mt--60">
              <a class="btn-default btn-primary round btn-icon" href="/news-list">
                查看更多<Icon name="arrow-right" size="20" icon-class="icon"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../components/icon/Icon'
import BlogPost from '../../components/blog/BlogPost'

import SectionTitle from "../../components/elements/sectionTitle/SectionTitle";
import HomePost from "./HomePost";

export default {
  name: 'BlogListPage',
  components: {Icon, BlogPost,SectionTitle,HomePost},
  //mixins: [BlogPostMixin],
  props:{
    newsList:{
      type: Array,
      default:()=>[]
    }
  },
  data(){
    return{

    }
  },
  created() {
  },
  methods:{

  }
}
</script>